import { FC } from "react"
import { usePromotionEvents } from "@shared/user-profile/hooks"
import ProfileEventCard from "../profile_event_card"
import LocationSpinner from "@/common/ui-kit/spinner"

const PromotionEventList: FC = () => {
  const { isLoading, error, state } = usePromotionEvents()
  if (isLoading)
    return (
      <div
        style={{
          minWidth: "calc(100vw - 16px)",
          textAlign: "center",
          padding: "48px 0",
        }}
      >
        <LocationSpinner />
      </div>
    )
  if (error) return <div>Error: {error.error}</div>

  return (
    <>
      {state?.length === 0 ? (
        <div
          style={{
            minWidth: "calc(100vw - 16px)",
            textAlign: "center",
            padding: "48px 0",
            color: "var(--Schemes-Primary)",
          }}
        >
          В этом разделе нет событий
        </div>
      ) : (
        state?.map((e) => (
          <ProfileEventCard isPromotion={true} info={e} key={e.id} />
        ))
      )}
    </>
  )
}

export default PromotionEventList
